import { mapActions, mapMutations, mapGetters, mapStates } from './../baseModule'

const collection = 'categories'
const singleName = 'categorie'
const pluralName = 'categories'
const connection = 'config'

const model = {
  name: '',
  apiEdu: false
}

const validations = {}

const getters = {}
getters[singleName] = (state) => {
  return Object.assign({}, model, state.one)
}
getters[pluralName] = (state) => state.all

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    one: Object.assign({}, model),
    validations
  },
  mutations: {
    ...mapMutations()
  },
  actions: {
    ...mapActions(collection, model, connection)
  },
  getters: {
    ...mapGetters(),
    ...getters,
    loading: state => state.loading,
    validations: state => state.validations,
    filtersTags: state => state.all.reduce(function (accumulate, current) {
      accumulate[current._id] = []
      return accumulate
    }, {}),
    categoriesApi: state => state.all.filter(item => {
      return item.hasOwnProperty('apiEdu') && item.apiEdu
    })
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/categories.js